import { createPortal } from 'react-dom';
import { FormattedMessage } from 'react-intl';

import useTokenExpirationGuard from './token-expiration-guard.controller';

const TokenExpirationGuard = () => {
    const viewProps = useTokenExpirationGuard();

    if (!viewProps.showWarning) return <></>;

    return createPortal(
        <div
            id='token-expiration-guard'
            className='fixed inset-0 flex items-center justify-center backdrop-brightness-50'
            style={{ zIndex: 99999 }}>
            <div className='bg-background-surface m-12 overflow-hidden rounded-2xl p-6'>
                <div className='flex flex-col items-center justify-start gap-6'>
                    <div className='flex flex-col items-start gap-2 self-stretch'>
                        <p className='text-foreground-default text-xl font-semibold'>
                            <FormattedMessage
                                id='kiosk.tokenExpirationGuard.title'
                                defaultMessage='Session expiring'
                                description='Title of the session expiration warning modal on the kiosk'
                            />
                        </p>
                        <p className='text-foreground-default text-base'>
                            <FormattedMessage
                                id='kiosk.tokenExpirationGuard.message'
                                defaultMessage='Your session is about to expire. You will be automatically logged out in {secondsRemaining} seconds.'
                                description='Message shown when the user session token is about to expire on the kiosk'
                                values={{ secondsRemaining: viewProps.secondsRemaining }}
                            />
                        </p>
                    </div>
                    <div className='w-full'>
                        <button
                            onClick={viewProps.onLogout}
                            data-testid='session-expiry-logout-button'
                            className='bg-brand-primary inline-flex w-full items-center justify-center gap-2 rounded-xl px-4 py-3'>
                            <span className='text-background-surface text-base font-medium'>
                                <FormattedMessage
                                    id='kiosk.tokenExpirationGuard.logoutNow'
                                    defaultMessage='Log out now'
                                    description='Button to log out immediately when the session is expiring on the kiosk'
                                />
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </div>,
        document.body
    );
};

export default TokenExpirationGuard;
